import * as Yup from "yup";

const isDuplicateFieldName = (
  existingValues: [],
  fieldName: string,
  isNew: boolean
) => {
  if (isNew) {
         return existingValues
    ?.some(
      (item: any) =>
        item.fieldName?.trim()?.toLowerCase() ===
        fieldName?.trim()?.toLowerCase()
    );
  }else{
    false
  }
};


export default (existingValues: any, isNew:boolean) => {
  return Yup.object().shape({

    informationList: Yup.array().of(
      Yup.object().shape({
        key: Yup.string()
          .nullable()
          .required("US.COLLECTION.VALIDATIONS:REQUIRED.HEADER_IS_REQUIRED")
          .test(
            "is-duplicate",
            "US.COLLECTION.VALIDATIONS:INVALID.THIS_NAME_IS_ALREADY_TAKEN",
            function (value) {
              return !isDuplicateFieldName(
                existingValues,
                value || "",
                isNew
              );
            }
          ),

        value: Yup.string()
          .nullable()
          .required("US.COLLECTION.VALIDATIONS:REQUIRED.VALUE_IS_REQUIRED"),
      })
    ),
  });
};
